import React from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export const TopBar = ({ title, subtitle, user, onAvatarClick, right }) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between gap-3 mb-4" data-testid="top-bar">
      <div className="min-w-0">
        <h1 className="font-serif text-2xl sm:text-3xl font-semibold leading-tight" data-testid="top-bar-title">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5" data-testid="top-bar-subtitle">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {right}
        <button onClick={() => navigate('/notifications')} aria-label="Notifications" data-testid="topbar-notifications-button" className="h-10 w-10 rounded-xl border border-border bg-card flex items-center justify-center text-foreground/80 hover:bg-secondary transition-colors">
          <Bell className="h-4.5 w-4.5" />
        </button>
        {user && (
          <button onClick={onAvatarClick || (() => navigate('/profile'))} data-testid="topbar-avatar-button">
            <Avatar className="h-10 w-10 ring-1 ring-border">
              <AvatarImage src={user.picture} alt={user.name} />
              <AvatarFallback>{(user.name || 'M').slice(0,1).toUpperCase()}</AvatarFallback>
            </Avatar>
          </button>
        )}
      </div>
    </div>
  );
};
